import config from '../config';
import Request from './request';

const { aws: { api: { invokeUrl } } } = config;

export const getCCEmails = () => Request.get(`${invokeUrl}/admin/cc-emails`, true);
export const updateCCEmails = (emails) => Request.patch(`${invokeUrl}/admin/cc-emails`, { emails }, true);